import { render, staticRenderFns } from "./wishlist_list.vue?vue&type=template&id=22b7530e&scoped=true&"
import script from "./wishlist_list.vue?vue&type=script&lang=js&"
export * from "./wishlist_list.vue?vue&type=script&lang=js&"
import style0 from "./wishlist_list.vue?vue&type=style&index=0&id=22b7530e&prod&scoped=true&lang=css&"
import style1 from "./wishlist_list.vue?vue&type=style&index=1&id=22b7530e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b7530e",
  null
  
)

export default component.exports